import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { Link, Heading, Badge } from '@americanexpress/dls-react';
import { IconStar } from '@americanexpress/dls-icons';
import { useIntl } from 'react-intl';

import MarketingTileImage from './MarketingTileImage/MarketingTileImage';
import style from './MarketingTile.scss';

const MarketingTile = ({
  content: {
    heading,
    subHeading,
    ctaLabel,
    redirectUrl,
    analyticElement: analyticDetail,
    imageUrl,
    imageLocationLabel,
    imageLabel,
    reactlyticsDetail = '',
    hasDisplayEarlyTenureBadge = false,
  },
  index,
}) => {
  const isBottomTile = index === 3 || index === 4;
  const analyticElement = reactlyticsDetail || `hp-tiles-L${index}-banner`;
  const { formatMessage } = useIntl();

  return (
    <div id={`marketingTile${index}`} className="position-relative">
      {hasDisplayEarlyTenureBadge && (
        <Badge
          className={style.badge}
          type="text"
          status="information"
          icon={<IconStar size="lg" isFilled={true} />}
        >
          {formatMessage({ id: 'marketingTile.label' })}
        </Badge>
      )}
      <MarketingTileImage
        image={imageUrl}
        caption={imageLocationLabel}
        title={imageLabel}
        isBottomTile={isBottomTile}
      />
      <div
        className={clsx(`color-surface-bg ${style.link}`, {
          'pad-2-lr-sm-down': isBottomTile,
        })}
      >
        {heading && (
          <>
            <Heading level={3} variant="sans-small-regular" className="pad-1-b">
              <span
                // eslint-disable-next-line react/no-danger -- data from oneCMS
                dangerouslySetInnerHTML={{
                  __html: sanitize(`${heading} `),
                }}
              />
            </Heading>
            <span
              // eslint-disable-next-line react/no-danger -- data from oneCMS
              dangerouslySetInnerHTML={{
                __html: sanitize(`${subHeading} `),
              }}
            />
          </>
        )}
        {redirectUrl && (
          <Link
            isInline={true}
            href={redirectUrl}
            rel="noopener noreferrer"
            identifier={analyticDetail}
            reactlytics={{
              element: analyticElement,
              detail: analyticDetail,
            }}
          >
            {ctaLabel}
          </Link>
        )}
      </div>
    </div>
  );
};

MarketingTile.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    ctaLabel: PropTypes.string,
    redirectUrl: PropTypes.string,
    imageUrl: PropTypes.string,
    analyticElement: PropTypes.string,
    imageLocationLabel: PropTypes.string,
    imageLabel: PropTypes.string,
    reactlyticsDetail: PropTypes.string,
    hasDisplayEarlyTenureBadge: PropTypes.bool,
  }),
  index: PropTypes.number.isRequired,
};

MarketingTile.defaultProps = {
  content: {},
};

export default MarketingTile;
